// Component for creating an occasion
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const CreateOccasion = () => {
    const [outfits, setOutfits] = useState([]);
    const [selectedOutfits, setSelectedOutfits] = useState([]);
    const [occasionName, setOccasionName] = useState('');
    const [location, setLocation] = useState('');
    const [description, setDescription] = useState('');
    const [expandedOutfits, setExpandedOutfits] = useState({}); // Track expanded state for outfits

    const [outfitNameSearchTerm, setOutfitNameSearchTerm] = useState('');
    const [occasionSearchTerm, setOccasionSearchTerm] = useState('');
    const [clothingItemSearchTerm, setClothingItemSearchTerm] = useState('');

    const navigate = useNavigate();

    useEffect(() => {
        fetchOutfits(); // Fetch outfits when component loads
    }, []);

    const fetchOutfits = async () => {
        try {
            const response = await axios.get('http://localhost:3000/api/outfits', {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            setOutfits(response.data);
        } catch (error) {
            console.error('Error fetching outfits:', error.response ? error.response.data : error.message);
        }
    };

    const handleOutfitsSelect = (outfitId) => {
        setSelectedOutfits((prevSelected) =>
            prevSelected.includes(outfitId)
                ? prevSelected.filter((id) => id !== outfitId)
                : [...prevSelected, outfitId]
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const occasionData = {
            occasion_name: occasionName,
            location: location.split(',').map(loc => loc.trim()),
            description: description,
            outfits: selectedOutfits
        };

        try {
            await axios.post('http://localhost:3000/api/occasions', occasionData, {
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
            });
            navigate('/occasions'); // Redirect to Occasions page
        } catch (error) {
            console.error('Error creating occasion:', error.response ? error.response.data : error.message);
            alert('Error creating occasion. Please try again.');
        }
    };

    const toggleOutfitDetails = (outfitId) => {
        setExpandedOutfits(prevState => ({
            ...prevState,
            [outfitId]: !prevState[outfitId]  // Toggle expanded state for the specific outfit
        }));
    };

    const filteredOutfits = outfits.filter(outfit => {
        const matchesOutfitName = outfit.outfit_name.toLowerCase().includes(outfitNameSearchTerm.toLowerCase());
        const matchesOccasions = outfit.occasion.some(occ => occ.toLowerCase().includes(occasionSearchTerm.toLowerCase()));
        const matchesClothingItems = outfit.clothing_items.some(cloth => 
            cloth.cloth_name.toLowerCase().includes(clothingItemSearchTerm.toLowerCase()) ||
            cloth.color.some(col => col.toLowerCase().includes(clothingItemSearchTerm.toLowerCase())) || 
            cloth.category.some(cat => cat.toLowerCase().includes(clothingItemSearchTerm.toLowerCase())) ||
            cloth.season.some(sea => sea.toLowerCase().includes(clothingItemSearchTerm.toLowerCase()))
        );

        return matchesOutfitName && matchesOccasions && matchesClothingItems;
    });

    return (
        <div className="create-occasion-container">
            <h2><strong>𝒞𝓇𝑒𝒶𝓉𝑒 𝒪𝒸𝒸𝒶𝓈𝒾𝑜𝓃</strong></h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <strong>Name:</strong>
                    <input
                        type="text"
                        value={occasionName}
                        onChange={(e) => setOccasionName(e.target.value)}
                        placeholder="Enter occasion name"
                        required
                    />
                </label>
                <label>
                    <strong>Location:</strong>
                    <input
                        type="text"
                        value={location}
                        onChange={(e) => setLocation(e.target.value)}
                        placeholder="e.g. University, Bar (separate with commas)"
                        required
                    />
                </label>
                <label>
                    <strong>Description:</strong>
                    <input
                        type="text"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        placeholder="Short Occasion Description (optional)"
                    />
                </label>

                <div className="outfit-search-section">
                    <h3><strong>𝒮𝑒𝒶𝓇𝒸𝒽 & 𝒮𝑒𝓁𝑒𝒸𝓉 𝒪𝓊𝓉𝒻𝒾𝓉𝓈:</strong></h3>
                    <input
                        type="text"
                        placeholder="Search by outfit name"
                        value={outfitNameSearchTerm}
                        onChange={(e) => setOutfitNameSearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by occasions"
                        value={occasionSearchTerm}
                        onChange={(e) => setOccasionSearchTerm(e.target.value)}
                    />
                    <input
                        type="text"
                        placeholder="Search by clothing items"
                        value={clothingItemSearchTerm}
                        onChange={(e) => setClothingItemSearchTerm(e.target.value)}
                    />

                    {filteredOutfits.map((outfit) => (
                        <div
                            key={outfit._id}
                            className={`outfit-selection ${selectedOutfits.includes(outfit._id) ? 'selected' : ''}`}
                            onClick={() => {
                                handleOutfitsSelect(outfit._id);
                                toggleOutfitDetails(outfit._id);
                            }}
                        >
                            <strong>{outfit.outfit_name}</strong>

                            {expandedOutfits[outfit._id] && (
                                <div className="clothing-items-dropdown">
                                    {outfit.clothing_items.map((cloth) => (
                                        <div key={cloth._id} className="clothing-item">
                                            <img src={cloth.image_url} alt={cloth.cloth_name} />
                                            <p>{cloth.cloth_name}</p>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

                <button type="submit" className="create-btn"><i className="fa-solid fa-plus"></i> <strong>𝒞𝓇𝑒𝒶𝓉𝑒</strong></button>
            </form>
        </div>
    );
};

export default CreateOccasion;